import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import diningRestaurant from "@/assets/dining-restaurant.png";
import diningBuffet from "@/assets/dining-buffet.png";
import esosInterior from "@/assets/esos-grill-interior.png";
import esosGarden from "@/assets/esos-grill-garden.png";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const HomeDining = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  return (
    <section className="hotel-section bg-card">
      <div className="hotel-container">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
          <p className="hotel-caption text-accent mb-4">{get("dining_subtitle") || t.homeDining.caption}</p>
          <h2 className="hotel-heading text-foreground mb-6">{get("dining_title") || t.homeDining.cafeHeading}</h2>
          <p className="hotel-body text-muted-foreground">{get("dining_description") || t.homeDining.text}</p>
        </div>
        <div className="grid md:grid-cols-2 gap-4 md:gap-8">
          <div className="bg-primary rounded-lg overflow-hidden shadow-soft">
            <div className="grid grid-cols-2 gap-1">
              <img src={diningRestaurant} alt="Restaurant" loading="lazy" className="w-full h-36 md:h-56 object-cover" />
              <img src={diningBuffet} alt="Breakfast Buffet" loading="lazy" className="w-full h-36 md:h-56 object-cover" />
            </div>
            <div className="p-5 md:p-8">
              <h3 className="font-display text-xl md:text-2xl font-semibold text-primary-foreground mb-3">
                {get("dining_breakfast_title") || t.homeDining.breakfastTitle}
              </h3>
              <p className="font-body text-sm text-primary-foreground/85 leading-relaxed mb-4">
                {get("dining_breakfast_text") || t.homeDining.breakfastText}
              </p>
              <div className="space-y-1">
                <p className="font-body text-sm text-accent font-medium">{get("dining_breakfast_time") || t.homeDining.breakfastTime}</p>
                <p className="font-body text-sm text-accent font-medium">{get("dining_dinner_time") || t.homeDining.dinnerTime}</p>
              </div>
            </div>
          </div>
          <div className="bg-primary rounded-lg overflow-hidden shadow-soft">
            <div className="grid grid-cols-2 gap-1">
              <img src={esosInterior} alt="Esos Grill" loading="lazy" className="w-full h-36 md:h-56 object-cover" />
              <img src={esosGarden} alt="Esos Grill Garden" loading="lazy" className="w-full h-36 md:h-56 object-cover" />
            </div>
            <div className="p-5 md:p-8">
              <h3 className="font-display text-xl md:text-2xl font-semibold text-primary-foreground mb-3">
                {get("dining_grill_title") || t.homeDining.grillTitle}
              </h3>
              <p className="font-body text-sm text-primary-foreground/85 leading-relaxed mb-4">
                {get("dining_grill_text") || t.homeDining.grillText}{" "}
                <span className="text-accent font-medium">{get("dining_grill_highlight") || t.homeDining.grillHighlight}</span>{" "}
                {get("dining_grill_desc") || t.homeDining.grillDesc}
              </p>
              <a href="https://esosgrill.ch" target="_blank" rel="noopener noreferrer"
                className="inline-block border border-primary-foreground/60 text-primary-foreground font-body text-xs uppercase tracking-wider font-medium px-4 py-2 rounded-sm hover:bg-primary-foreground hover:text-primary transition-colors mb-4">
                ESOSGRILL.CH
              </a>
              <p className="font-body text-sm text-accent font-medium">{get("dining_grill_hours") || t.homeDining.grillHours}</p>
            </div>
          </div>
        </div>
        <div className="text-center mt-10">
          <Button variant="hotel" size="lg" asChild>
            <Link to="/restaurant">{t.homeDining.cta}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HomeDining;
